/*
  The black bag drawer of the reels: items, "Troca os teus Peachies", "Os teus vouchers", discount
  codes, total and the theme cart's notices. Markup and styles: snippets/reels-bag.liquid.

  Shared by the New Experience page (assets/new-experience.js adds these methods to its reel)
  and by the site's bottom bar in reels mode (ReelsSiteBag below), so both bags are the same.
  The methods expect: this.bag (the drawer), this.root (an element with data-error-text,
  data-customer), this.moneyFormat, this.renderCart(), this.showToast(text, isError) and,
  optionally, this.pendingItems / this.pendingCents (adds still on their way).
*/

/*
  window.ReelsTrack: the New Experience's own events for Google (GA4 + Ads), Meta and Klaviyo.
  Shopify only sends its standard events (page, product page, add to cart, checkout); what happens
  inside the reel (products seen, collections and searches loaded in place, the bag, leaving, the
  app) is sent from here, through the tags the shop's apps already load on the page (gtag, fbq,
  klaviyo). Google follows its own consent mode; Meta and Klaviyo only with marketing consent.
  Every Google event sent from here carries experience: new_experience, and the visitor gets the
  user property new_experience: yes (so Shopify's own add_to_cart and purchase can be compared).
*/
(function () {
  if (window.ReelsTrack) return;

  var queue = [];
  var tries = 0;
  var timer = null;

  // Google's tag is ready once the Google & YouTube app has configured its GA4 property
  function analyticsIds() {
    var ids = [];
    (window.dataLayer || []).forEach(function (entry) {
      if (entry && entry[0] === 'config' && /^G-/.test(entry[1] || '') && ids.indexOf(entry[1]) === -1) ids.push(entry[1]);
    });
    return ids;
  }
  function googleReady() {
    return typeof window.gtag === 'function' && analyticsIds().length > 0;
  }

  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!(privacy && privacy.marketingAllowed && privacy.marketingAllowed());
    } catch (e) {
      return false;
    }
  }

  var googleSet = false;
  function send(item, google) {
    if (google && !googleSet) {
      googleSet = true;
      // Who has used the New Experience (a user property: her later visits and orders compare too)
      window.gtag('set', 'user_properties', { new_experience: 'yes', app_mode: appMode() });
    }
    if (google && item.google) {
      var params = item.google[1] || {};
      params.experience = 'new_experience';
      params.app_mode = appMode();
      // Analytics only (not Google Ads): virtual page views, lists, the bag, leaving...
      if (item.analyticsOnly) params.send_to = analyticsIds();
      window.gtag('event', item.google[0], params);
    }
    if (item.meta && typeof window.fbq === 'function' && marketingAllowed()) {
      window.fbq('track', item.meta[0], item.meta[1]);
    }
    if (item.klaviyo && window.klaviyo && typeof window.klaviyo.push === 'function' && marketingAllowed()) {
      window.klaviyo.push(item.klaviyo);
    }
  }

  // The apps' tags load after the page: events wait for them (up to ~15 s), in order
  function flush() {
    timer = null;
    if (!googleReady() && tries < 30) {
      tries += 1;
      timer = setTimeout(flush, 500);
      return;
    }
    var ready = googleReady();
    queue.splice(0).forEach(function (item) { send(item, ready); });
  }

  function appMode() {
    var standalone = window.navigator.standalone || (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
    return standalone ? 'app' : 'browser';
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var country = ((window.Shopify && window.Shopify.country) || 'PT').toUpperCase();

  window.ReelsTrack = {
    // item: { google: [name, params], analyticsOnly: true|false, meta: [name, params], klaviyo: [...] }
    push: function (item) {
      queue.push(item);
      if (!timer) flush();
    },
    // Same item format as the Google & YouTube app (Merchant Center ids: shopify_PT_<product>_<variant>)
    googleItem: function (product, size, index) {
      var item = {
        id: 'shopify_' + country + '_' + product.id + '_' + size.id,
        item_id: 'shopify_' + country + '_' + product.id + '_' + size.id,
        item_name: product.title,
        item_brand: product.vendor || '',
        item_category: product.type || '',
        item_variant: size.variantTitle || size.label || '',
        price: (size.cents || 0) / 100,
        quantity: 1
      };
      if (size.sku) item.sku = size.sku;
      if (index != null) item.index = index;
      return item;
    },
    url: function (path) {
      return window.location.origin + (path || '').split('#')[0];
    },
    root: root,
    appMode: appMode
  };

  // Google: the user property is set as soon as the tag is ready (before Shopify's add_to_cart)
  var html = document.documentElement;
  if (html.classList.contains('reels-early') || html.classList.contains('reels-apps')) {
    window.ReelsTrack.push({});
  }
})();

(function () {
  if (window.ReelsBagMethods) return;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  var methods = {};

  /* ---------- bag drawer ---------- */

  // Fills the drawer from the cart (Ajax API); every change goes through the same queue as the adds
  methods.renderBag = function (cart) {
    var self = this;
    var bag = this.bag;
    if (!bag) return;
    var list = bag.querySelector('[data-bag-items]');
    list.textContent = '';
    bag.querySelector('[data-bag-empty]').hidden = cart.item_count > 0;
    bag.querySelector('[data-bag-foot]').hidden = cart.item_count === 0;
    bag.querySelector('[data-bag-subtotal]').textContent = this.formatMoney(cart.total_price);
    this.lastCart = cart;
    this.renderEarn();
    this.renderBagCodes(cart);
    cart.items.forEach(function (item) {
      var row = el('div', 'reels__bag-item');
      var image = item.image;
      if (image) {
        var link = el('a');
        link.href = item.url;
        var img = el('img');
        img.src = image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=180';
        img.alt = '';
        img.loading = 'lazy';
        link.appendChild(img);
        row.appendChild(link);
      }
      var info = el('div', 'reels__bag-info');
      var name = el('a', 'reels__bag-name', item.product_title);
      name.href = item.url;
      info.appendChild(name);
      if (item.variant_title) info.appendChild(el('span', 'reels__bag-variant', item.variant_title));
      var line = el('div', 'reels__bag-row');
      var qty = el('div', 'reels__bag-qty');
      var minus = el('button', '', '\u2212');
      minus.type = 'button';
      minus.setAttribute('aria-label', '-1');
      var plus = el('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', '+1');
      qty.appendChild(minus);
      qty.appendChild(el('span', '', String(item.quantity)));
      qty.appendChild(plus);
      line.appendChild(qty);
      var price = el('span', 'reels__bag-price');
      if (item.original_line_price > item.final_line_price) price.appendChild(el('s', '', self.formatMoney(item.original_line_price)));
      price.appendChild(document.createTextNode(self.formatMoney(item.final_line_price)));
      line.appendChild(price);
      info.appendChild(line);
      var remove = el('button', 'reels__bag-remove', bag.dataset.removeText || '');
      remove.type = 'button';
      info.appendChild(remove);
      row.appendChild(info);
      minus.addEventListener('click', function () { self.changeBag(item.key, item.quantity - 1, row); });
      plus.addEventListener('click', function () { self.changeBag(item.key, item.quantity + 1, row); });
      remove.addEventListener('click', function () { self.changeBag(item.key, 0, row); });
      list.appendChild(row);
    });
  };

  // Discount codes: the ones in the cart (tap removes) and the suggested ones (tap applies)
  methods.renderBagCodes = function (cart) {
    var self = this;
    var bag = this.bag;
    var box = bag.querySelector('[data-bag-codes]');
    if (!box) return;
    box.textContent = '';
    // Her own vouchers get their own block ("Os teus vouchers"); other codes stay in the row below
    var vouchers = bag.querySelector('[data-bag-vouchers]');
    var voucherBox = bag.querySelector('[data-bag-voucher-codes]');
    if (voucherBox) voucherBox.textContent = '';
    var ends = {};
    (this.rewards || []).forEach(function (item) { ends[item.code.toUpperCase()] = item.ends; });
    var boxFor = function (code) {
      return voucherBox && code.toUpperCase() in ends ? voucherBox : box;
    };
    var until = function (chip, code) {
      var date = ends[code.toUpperCase()];
      if (!date || !vouchers) return;
      var day = new Date(date).toLocaleDateString((window.Shopify && window.Shopify.locale) || 'pt-PT', { day: 'numeric', month: 'numeric' });
      chip.appendChild(el('small', '', (vouchers.dataset.untilText || '[data]').replace('[data]', day)));
    };
    // Suggested: the customer's own Peach Lovers vouchers (by name) and the codes set in the section
    var labels = {};
    var items = (this.rewards || []).concat((bag.dataset.codes || '').split(',').map(function (code) {
      return { code: code.trim(), label: code.trim() };
    }));
    items.forEach(function (item) {
      var key = item.code.toUpperCase();
      if (item.code && !labels[key]) labels[key] = item.label;
    });
    // Her vouchers count as applied even when the cart can't price them yet (free shipping)
    var rewardCodes = (this.rewards || []).map(function (item) { return item.code.toUpperCase(); });
    var applied = (cart.discount_codes || []).filter(function (code) {
      return code.applicable || rewardCodes.indexOf(code.code.toUpperCase()) !== -1;
    }).map(function (code) { return code.code; });
    var upper = applied.map(function (code) { return code.toUpperCase(); });
    var suggested = [];
    items.forEach(function (item) {
      var key = item.code.toUpperCase();
      if (item.code && upper.indexOf(key) === -1 && suggested.indexOf(item.code) === -1) suggested.push(item.code);
    });
    applied.forEach(function (code) {
      var chip = el('button', 'reels__bag-code is-applied', (labels[code.toUpperCase()] || code) + ' \u00d7');
      chip.type = 'button';
      chip.addEventListener('click', function () {
        chip.classList.add('is-busy');
        self.setBagCodes(applied.filter(function (other) { return other !== code; }));
      });
      boxFor(code).appendChild(chip);
    });
    suggested.forEach(function (code) {
      var chip = el('button', 'reels__bag-code', '+ ' + labels[code.toUpperCase()]);
      chip.type = 'button';
      until(chip, code);
      chip.addEventListener('click', function () {
        chip.classList.add('is-busy');
        self.applyBagCode(code);
      });
      boxFor(code).appendChild(chip);
    });
    if (vouchers) {
      vouchers.hidden = !voucherBox.children.length;
      // "Tens um voucher…" or "Tens vouchers…"
      var voucherText = vouchers.querySelector('[data-bag-vouchers-text]');
      if (voucherText) voucherText.textContent = voucherBox.children.length === 1 ? voucherText.dataset.one : voucherText.dataset.many;
    }
    var discount = bag.querySelector('[data-bag-discount]');
    discount.hidden = !(cart.total_discount > 0);
    bag.querySelector('[data-bag-discount-value]').textContent = '\u2212' + this.formatMoney(cart.total_discount || 0);
    this.bagCodes = applied;
  };

  // Sets the cart's codes (Ajax API: /cart/update.js with "discount"), through the cart queue
  methods.setBagCodes = function (codes, check) {
    var self = this;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.cartQueue = (this.cartQueue || Promise.resolve()).then(function () {
      return fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (check && !check(cart)) {
          // A code that doesn't apply to this cart: tell her and keep the cart as it was
          self.showToast(self.bag.dataset.discountError || self.root.dataset.errorText, true);
          self.setBagCodes(self.bagCodes || []);
          return;
        }
        self.cartItems = cart.item_count + (self.pendingItems || 0);
        self.cartCents = cart.total_price + (self.pendingCents || 0);
        self.renderCart(false);
        self.renderBag(cart);
      })
      .catch(function () {
        self.showToast(self.root.dataset.errorText, true);
        self.openBag(true);
      });
    });
  };

  methods.applyBagCode = function (code) {
    code = String(code || '').trim();
    if (!code) return;
    var current = this.bagCodes || [];
    if (current.some(function (other) { return other.toUpperCase() === code.toUpperCase(); })) return;
    this.setBagCodes(current.concat(code), function (cart) {
      return (cart.discount_codes || []).some(function (other) {
        return other.code.toUpperCase() === code.toUpperCase() && other.applicable;
      });
    });
  };

  // Growave's storefront API with the session token its own widgets use (logged-in customers)
  methods.growave = function (path, options) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var attempts = 0;
    return new Promise(function (resolve) {
      var check = function () {
        var manager = window.gw && window.gw.legacyAdapter && window.gw.legacyAdapter.tokenManager;
        var value = null;
        try {
          if (manager && manager.isCustomer()) value = manager.getToken();
        } catch (e) {}
        if (value || ++attempts > 20) resolve(value || null);
        else setTimeout(check, 300);
      };
      check();
    }).then(function (token) {
      if (!token) throw new Error('');
      options = options || {};
      var headers = { authorization: 'Bearer ' + token, 'x-gw-token-strategy': 'growave' };
      if (options.body) headers['Content-Type'] = 'application/json';
      return fetch(base + 'apps/ssw/storefront-api/rewards-storefront/' + path, {
        method: options.body ? 'POST' : 'GET',
        headers: headers,
        body: options.body ? JSON.stringify(options.body) : undefined
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.message || '');
          return data;
        });
      });
    });
  };

  // Peachies -> voucher: balance and the vouchers she can swap for (fixed price, discount or shipping)
  methods.loadPeach = function () {
    var self = this;
    var box = this.bag && this.bag.querySelector('[data-bag-peach]');
    if (!box) return;
    var locale = encodeURIComponent((window.Shopify && window.Shopify.locale) || 'pt-PT');
    var query = '?x-gw-current-app=default&designMode=false&locale=' + locale;
    Promise.all([
      this.growave('v2/general/getRewardsProgramAccount' + query),
      this.growave('v3/spends/getSpendingRules' + query)
    ]).then(function (results) {
      var account = results[0];
      if (!account.isRewardProgramAvailableForCustomer) return;
      self.peachBalance = (account.points && account.points.balance) || 0;
      self.peachRules = (results[1].items || []).map(function (item) {
        var rule = item.rule || {};
        var reward = (item.rewards || [])[0] || {};
        var kinds = ['FIXED_PERCENTAGE_DISCOUNT', 'FIXED_AMOUNT_DISCOUNT', 'SHIPPING_DISCOUNT'];
        if (!rule.ruleId || !reward.templateId || !(rule.pointsPrice > 0) || kinds.indexOf(reward.rewardType) === -1) return null;
        var tags = rule.customerTags || {};
        return {
          id: rule.ruleId,
          template: reward.templateId,
          title: rule.title,
          points: rule.pointsPrice,
          only: tags.whitelist || [],
          not: tags.blacklist || []
        };
      }).filter(Boolean).sort(function (a, b) { return a.points - b.points; });
      self.renderPeach();
    }).catch(function () {});
  };

  // "Ganhas X Peachies" next to the bag's title, for the cart as it is now: the theme cart's rule
  // (total in euros x her tier's multiplier, rounded down; see snippets/cart-form.liquid)
  methods.renderEarn = function () {
    var badge = this.bag && this.bag.querySelector('[data-bag-earn]');
    if (!badge) return;
    var multiplier = parseFloat(badge.dataset.multiplier) || 1;
    var euros = this.lastCart ? this.lastCart.total_price / 100 : 0;
    var points = Math.floor(euros * multiplier);
    badge.textContent = (badge.dataset.text || '[pontos]').replace('[pontos]', points);
    badge.hidden = !(points > 0);
  };

  methods.renderPeach = function () {
    var self = this;
    var box = this.bag.querySelector('[data-bag-peach]');
    var list = box.querySelector('[data-bag-peach-list]');
    var pointsText = function (points) {
      return (box.dataset.pointsText || '[pontos]').replace('[pontos]', points);
    };
    box.querySelector('[data-bag-peach-balance]').textContent = pointsText(this.peachBalance);
    list.textContent = '';
    // The vouchers of her tier: each one lists the tiers (customer tags) allowed or excluded
    var tags = [];
    try { tags = JSON.parse(box.dataset.tags || '[]'); } catch (e) {}
    var has = function (names) {
      return names.some(function (tag) { return tags.indexOf(tag) !== -1; });
    };
    var rules = (this.peachRules || []).filter(function (rule) {
      return (!rule.only.length || has(rule.only)) && !has(rule.not);
    });
    // Not enough Peachies for any: just how many are missing for the nearest one
    var affordable = rules.filter(function (rule) { return rule.points <= self.peachBalance; });
    var missing = box.querySelector('[data-bag-peach-missing]');
    var nearest = rules[0];
    missing.hidden = !!affordable.length || !nearest;
    if (nearest && !affordable.length) {
      missing.textContent = (box.dataset.missingText || '')
        .replace('[pontos]', nearest.points - this.peachBalance)
        .replace('[voucher]', nearest.title);
    }
    list.hidden = !affordable.length;
    rules.forEach(function (rule) {
      var item = el('button', 'reels__bag-peach-item');
      item.type = 'button';
      // Only the name; on the first tap: its cost and "Toca para trocar"
      var name = el('strong', '', rule.title);
      item.appendChild(name);
      item.appendChild(el('span', '', box.dataset.confirmText || ''));
      item.disabled = rule.points > self.peachBalance;
      var timer = null;
      item.resetConfirm = function () {
        clearTimeout(timer);
        item.classList.remove('is-confirm');
        name.textContent = rule.title;
      };
      // First tap asks, second tap swaps (Peachies are spent for real)
      item.addEventListener('click', function () {
        if (!item.classList.contains('is-confirm')) {
          list.querySelectorAll('.is-confirm').forEach(function (other) { other.resetConfirm(); });
          item.classList.add('is-confirm');
          name.textContent = pointsText(rule.points);
          timer = setTimeout(item.resetConfirm, 4000);
          return;
        }
        clearTimeout(timer);
        item.classList.add('is-busy');
        self.redeemPeach(rule);
      });
      list.appendChild(item);
    });
    box.hidden = !rules.length;
  };

  methods.redeemPeach = function (rule) {
    var self = this;
    this.growave('v3/spends/redeemReward?x-gw-current-app=default', {
      body: { spendingRuleId: rule.id, rewardTemplateId: rule.template, pointsToSpend: rule.points }
    }).then(function (result) {
      self.peachBalance = Math.max(0, self.peachBalance - rule.points);
      if (window.ReelsTrack) window.ReelsTrack.push({ analyticsOnly: true, google: ['peachies_redeem', { points: rule.points, reward: rule.title || '' }] });
      self.renderPeach();
      self.rewardsPromise = null;
      if (result.rewardCode) {
        self.rewards = (self.rewards || []).concat({ code: result.rewardCode, label: rule.title, ends: null });
        // Straight into the cart (no "applies?" check: a shipping voucher only counts at checkout)
        self.setBagCodes((self.bagCodes || []).concat(result.rewardCode));
      }
      self.showToast(self.bag.querySelector('[data-bag-peach]').dataset.doneText || '', false);
      self.loadPeach();
    }).catch(function (error) {
      self.renderPeach();
      self.showToast((error && error.message) || self.root.dataset.errorText, true);
    });
  };

  // silent: a re-read after an error (not counted as the bag being opened)
  methods.openBag = function (silent) {
    var self = this;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Wait for adds still on their way, then show the real cart
    this.cartQueue = (this.cartQueue || Promise.resolve()).then(function () {
      return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          self.renderBag(cart);
          if (!silent && window.ReelsTrack) {
            var items = (cart.items || []).map(function (line, index) {
              var item = window.ReelsTrack.googleItem(
                { id: line.product_id, title: line.product_title, vendor: line.vendor, type: line.product_type },
                { id: line.variant_id, sku: line.sku, cents: line.final_price, variantTitle: line.variant_title },
                index
              );
              item.quantity = line.quantity;
              return item;
            });
            window.ReelsTrack.push({ analyticsOnly: true, google: ['view_cart', { currency: cart.currency, value: cart.total_price / 100, items: items }] });
          }
          // Her vouchers and Peachies arrive a moment later
          self.loadPeach();
          self.loadRewards().then(function (rewards) {
            if (!rewards.length) return;
            self.rewards = rewards;
            self.renderBagCodes(cart);
          });
        })
        .catch(function () {});
    });
  };

  // The logged-in customer's active Peach Lovers vouchers (Growave): read with the session token
  // Growave keeps on the page, the same request its own widgets make. Any failure just means
  // no vouchers are suggested.
  methods.loadRewards = function () {
    if (!this.root.dataset.customer) return Promise.resolve([]);
    if (this.rewardsPromise && Date.now() - this.rewardsAt < 60000) return this.rewardsPromise;
    this.rewardsAt = Date.now();
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var locale = (window.Shopify && window.Shopify.locale) || 'pt-PT';
    var attempts = 0;
    var token = new Promise(function (resolve) {
      var check = function () {
        var manager = window.gw && window.gw.legacyAdapter && window.gw.legacyAdapter.tokenManager;
        var value = null;
        try {
          if (manager && manager.isCustomer()) value = manager.getToken();
        } catch (e) {}
        if (value || ++attempts > 20) resolve(value || null);
        else setTimeout(check, 300);
      };
      check();
    });
    this.rewardsPromise = token
      .then(function (value) {
        if (!value) return { rewards: [] };
        return fetch(base + 'apps/ssw/storefront-api/rewards-storefront/v2/general/getCustomerActiveRewards?x-gw-current-app=default&designMode=false&locale=' + encodeURIComponent(locale), {
          headers: { authorization: 'Bearer ' + value, 'x-gw-token-strategy': 'growave' }
        }).then(function (response) { return response.ok ? response.json() : { rewards: [] }; });
      })
      .then(function (data) {
        var now = Date.now();
        return (data.rewards || []).map(function (item) {
          var reward = item.reward || {};
          if (!reward.discountCode) return null;
          if (reward.endsAt && new Date(reward.endsAt).getTime() < now) return null;
          if (reward.usageLimit && reward.usageCount >= reward.usageLimit) return null;
          return { code: reward.discountCode, label: (item.spendingRule && item.spendingRule.title) || reward.discountCode, ends: reward.endsAt || null };
        }).filter(Boolean);
      })
      .catch(function () { return []; });
    return this.rewardsPromise;
  };

  methods.changeBag = function (key, quantity, row) {
    var self = this;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (row) row.classList.add('is-busy');
    this.cartQueue = (this.cartQueue || Promise.resolve()).then(function () {
      return fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      })
      .then(function (response) {
        return response.json().then(function (data) {
          // Shopify explains refusals (e.g. no more stock): show its own message
          if (!response.ok) throw new Error(data.description || data.message || '');
          return data;
        });
      })
      .then(function (cart) {
        self.cartItems = cart.item_count + (self.pendingItems || 0);
        self.cartCents = cart.total_price + (self.pendingCents || 0);
        self.renderCart(false);
        self.renderBag(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (error) {
        if (row) row.classList.remove('is-busy');
        self.showToast((error && error.message) || self.root.dataset.errorText, true);
      });
    });
  };

  // Minimal Shopify money formatter (cents -> shop money format)
  methods.formatMoney = function (cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var thousands = function (separator) {
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };
    return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, type) {
      switch (type) {
        case 'amount_no_decimals': return thousands(',');
        case 'amount_with_comma_separator': return thousands('.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return thousands('.');
        case 'amount_with_apostrophe_separator': return thousands("'") + '.' + parts[1];
        default: return thousands(',') + '.' + parts[1];
      }
    });
  };

  // Close button and the discount code field
  methods.bindBag = function (bag, onClose) {
    var self = this;
    var bagClose = bag.querySelector('[data-bag-close]');
    if (bagClose) bagClose.addEventListener('click', onClose);
    var codeToggle = bag.querySelector('[data-bag-code-toggle]');
    var codeForm = bag.querySelector('[data-bag-code-form]');
    if (codeToggle && codeForm) {
      codeToggle.addEventListener('click', function () {
        codeForm.hidden = !codeForm.hidden;
        if (!codeForm.hidden) codeForm.querySelector('input').focus();
      });
      codeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = codeForm.querySelector('input');
        self.applyBagCode(input.value);
        input.value = '';
        input.blur();
        codeForm.hidden = true;
      });
    }
  };

  window.ReelsBagMethods = methods;

  /* ---------- the same bag on the site's pages (bottom bar in reels mode) ---------- */

  function ReelsSiteBag(bag) {
    var self = this;
    this.bag = bag;
    this.root = bag;
    this.moneyFormat = bag.dataset.moneyFormat || '{{amount_with_comma_separator}} \u20ac';
    this.cartItems = 0;
    this.cartCents = 0;
    this.bindBag(bag, function () { self.close(); });
    // A tap outside the bag (and the bar) closes it
    document.addEventListener('pointerdown', function (event) {
      if (bag.hidden || bag.contains(event.target) || event.target.closest('#ReelsNavBar')) return;
      self.close();
    }, true);
  }
  Object.keys(methods).forEach(function (name) { ReelsSiteBag.prototype[name] = methods[name]; });

  ReelsSiteBag.prototype.open = function () {
    this.bag.hidden = false;
    this.openBag();
  };
  ReelsSiteBag.prototype.close = function () {
    this.bag.hidden = true;
  };
  ReelsSiteBag.prototype.toggle = function () {
    if (this.bag.hidden) this.open();
    else this.close();
  };
  // The bar's badge and the theme's own cart counts
  ReelsSiteBag.prototype.renderCart = function () {
    var count = this.cartItems;
    document.querySelectorAll('[data-reels-bar-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-header-cart-count]').forEach(function (badge) {
      badge.textContent = count;
    });
  };
  ReelsSiteBag.prototype.showToast = function (text, isError) {
    var message = this.bag.querySelector('[data-bag-message]');
    if (!message || !text) return;
    message.textContent = text;
    message.classList.toggle('is-error', !!isError);
    message.hidden = false;
    clearTimeout(this.messageTimer);
    this.messageTimer = setTimeout(function () { message.hidden = true; }, 4000);
  };

  window.ReelsSiteBag = ReelsSiteBag;
})();
